export default __webpack_public_path__ + "static/3_18-1--72cee7957e16e2a9d6c59bed252c2c65.png";